module.exports = __webpack_public_path__ + "04_long_yellow.82b58ba6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/04_long_yellow.png
// module id = dgxW
// module chunks = 0